import React from "react";
import "./LanguageCard.css";

const LanguageCard = ({ language, points }) => {
  return (
    <div className="lc-wrapper">
      <h2 className="lc-language">{language}</h2>
      <div className="lc-points">
        {[...Array(points).keys()].map((i) => (
          <div className="lc-point"></div>
        ))}
        {[...Array(10 - points).keys()].map((i) => (
          <div className="lc-point lc-point-empty"></div>
        ))}
      </div>
    </div>
  );
};

export default LanguageCard;
